'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import ProgressModal from '../ui/ProgressModal';
import ProgressUpdate from './ProgressUpdate';

const Intro = () => {
  const [isViewStoriesHovered, setIsViewStoriesHovered] = useState(false);
  const [isViewFAQHovered, setIsViewFAQHovered] = useState(false);
  const [isViewProgressHovered, setIsViewProgressHovered] = useState(false); 
  const [isProgressModalOpen, setIsProgressModalOpen] = useState(false);

  return (
    <section id="about" className="py-12 bg-[#fff] " >
      <div className="mx-4 mt-4 mb-6">
      <div className="container mx-auto max-w-8xl">
        <div className="max-w-8xl mx-auto text-base md:text-lg text-[#005e60]">
          <hr style={{ borderColor: '#CDE4E4', borderWidth: '1px', marginBottom:'25px' }} />
          <h2 id="intro-heading" className="text-4xl md:text-5xl font-extrabold mb-8 text-[#005e60]" >WHAT IS CHANGING?</h2>
            <p className="leading-relaxed mb-5">
             In late 2024, GE Vernova retained Canadian engineering firm BBA to assess the condition of the vacant and unused buildings at its Peterborough site. The assessment found that most of the old manufacturing buildings are at or past their useful service life, in poor condition, and have already begun to show signs of structural degradation. The condition of these buildings could create a future safety risk if not managed properly now.</p>
            <p className="leading-relaxed mb-5">
             After careful consideration of the options, GE Vernova determined that the best course of action would be to demolish a number of these vacant buildings.
            </p>
            
            <h3 className="text-2xl md:text-3xl font-bold mb-4 mt-8 text-[#005e60]">
              Step One of the Process – Heritage Designation
            </h3>
            <p className="leading-relaxed mb-5">
             GE Vernova understands the importance this property holds for many members of the Peterborough community. In recognition of this, the company engaged ERA Architects, an award-winning Canadian architecture firm, to assess the site’s heritage value.</p>
            <p className="leading-relaxed mb-5">
             Between early September 2025 and late February 2026, the City of Peterborough completed its heritage review process for the site. As a result, the City of Peterborough adopted <a href="https://bylaws.peterborough.ca/bylaws/getFNDoc.do?class_id=20&document_id=14314" target="_blank">By-Law 26—023</a> which designated certain portions of the property which contained buildings that have heritage value.
            </p>
            
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-8xl mx-auto">
          <div
            className="relative rounded-xl overflow-hidden min-h-[350px] flex flex-col justify-end shadow-lg bg-[#4DD0D7]"
            style={{
              backgroundImage: "url('/viewstories.png')",
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <div className="p-16 ml-[-20px] flex flex-col h-full justify-end mb-10  items-center text-center sm:items-start sm:text-left">
              <h3 id="intro-heading" className="text-3xl md:text-3xl text-[#cde4e4] mb-2">
                PRESERVING OUR PAST
              </h3>
              <p className="mb-4 text-[#cde4e4]">Discover stories behind key landmarks.</p>
              <a
                href="#heritage"
                onMouseEnter={() => setIsViewStoriesHovered(true)}
                onMouseLeave={() => setIsViewStoriesHovered(false)}
                className="group inline-flex items-center justify-between w-42 bg-[#C8FF08] text-[#005e60] font-bold  pt-2 pb-2 pr-2 pl-6 rounded-full transition-colors duration-300 hover:bg-[#002D2E] hover:text-white"
              >
                <span>View Stories</span>
                <span className="flex items-center justify-center w-8 h-8 bg-white rounded-full transition-colors duration-300 group-hover:bg-[#C8FF08]">
                  {isViewStoriesHovered ? (
                    <Image src="/Arrow_hover.svg" alt="Arrow" width={50} height={50} />
                  ) : (
                    <Image src="/arrow.svg" alt="Arrow" width={50} height={50} />
                  )}
                </span>
              </a>
            </div>
          </div>
          <div
            className="relative rounded-xl overflow-hidden min-h-[350px] flex flex-col justify-end shadow-lg bg-[#005e60]"
            style={{
              backgroundImage: "url('/viewfaqsbg.png')",
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <div className="p-16 ml-[-20px] flex flex-col h-full justify-end mb-10 items-center text-center sm:items-start sm:text-left">
              <h3 id="intro-heading" className="text-3xl md:text-3xl text-[#cde4e4] mb-2">
                PROGRESS UPDATE
              </h3>
              <p className="mb-4 text-[#cde4e4]">Stay up to date with the process.</p>
              <button 
                onClick={() => setIsProgressModalOpen(true)}
                onMouseEnter={() => setIsViewProgressHovered(true)}
                onMouseLeave={() => setIsViewProgressHovered(false)}
                className="group inline-flex items-center justify-between w-42 bg-[#C8FF08] text-[#005e60] font-bold  pt-2 pb-2 pr-2 pl-6 rounded-full transition-colors duration-300 hover:bg-[#002D2E] hover:text-white"
              >
                <span>View Update</span>
                <span className="flex items-center justify-center w-8 h-8 bg-white rounded-full transition-colors duration-300 group-hover:bg-[#C8FF08]">
                  {isViewProgressHovered ? (
                    <Image src="/Arrow_hover.svg" alt="Arrow" width={50} height={50} />
                  ) : (
                    <Image src="/arrow.svg" alt="Arrow" width={50} height={50} />
                  )}
                </span>
              </button>
            </div>
          </div>
          <div
            className="relative rounded-xl overflow-hidden min-h-[220px] flex flex-col justify-end shadow-lg bg-[#007B7F] "
            style={{
              backgroundImage: "url('/viewfaqsbg.png')",
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <div className="p-16 ml-[-20px] flex flex-col h-full justify-end mb-10 items-center text-center sm:items-start sm:text-left">
              <h3 id="intro-heading" className="text-3xl md:text-3xl font-black mb-2 text-[#cde4e4]" >
                HAVE A QUESTION?
              </h3>
              <p className="mb-4 text-[#cde4e4]">The FAQ section is a good place to start.</p>
              <a
                href="#faq"
                onMouseEnter={() => setIsViewFAQHovered(true)}
                onMouseLeave={() => setIsViewFAQHovered(false)}
                className="group inline-flex items-center justify-between w-40 bg-[#C8FF08] text-[#005E60] font-bold  pt-2 pb-2 pr-2 pl-6 rounded-full transition-colors duration-300 hover:bg-[#002D2E] hover:text-white"
              >
                <span>View FAQ</span>
                <span className="flex items-center justify-center w-8 h-8 bg-white rounded-full transition-colors duration-300 group-hover:bg-[#C8FF08]">
                  {isViewFAQHovered ? (
                    <Image src="/Arrow_hover.svg" alt="Arrow" width={50} height={50} />
                  ) : (
                    <Image src="/arrow.svg" alt="Arrow" width={50} height={50} />
                  )}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      </div>
      <ProgressModal isOpen={isProgressModalOpen} onClose={() => setIsProgressModalOpen(false)}>
      <ProgressUpdate />
      </ProgressModal>
    </section>
  );
};

export default Intro;
